
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkles, Shirt, PaintBucket, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  return (
    <motion.div 
      className="relative pt-16 px-6 text-center"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div 
        className="inline-block mb-4"
        animate={{ rotate: [0, 5, -5, 0] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
      >
        <Sparkles className="h-16 w-16 text-madts-pink inline-block" />
      </motion.div>
      <h1 className="text-5xl md:text-7xl font-display font-bold mb-4 bg-gradient-to-r from-madts-purple via-madts-pink to-madts-blue bg-clip-text text-transparent">
        MAD-T's
      </h1>
      <motion.p 
        className="text-xl md:text-2xl font-body max-w-2xl mx-auto mb-8 text-gray-700"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        Custom T-shirt printing for parties & special events
      </motion.p>
      <motion.div
        className="flex flex-wrap justify-center gap-4 mb-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <Button 
          size="lg" 
          className="bg-madts-purple hover:bg-madts-purple/90 text-white font-medium"
          asChild
        >
          <Link to="/book">Book Now</Link>
        </Button>
        <Button 
          size="lg" 
          variant="outline" 
          className="border-madts-pink text-madts-pink hover:bg-madts-pink/10"
          asChild
        >
          <Link to="/shop">Explore Shop</Link>
        </Button>
      </motion.div>
      
      {/* Animated T-shirt */}
      <motion.div 
        className="relative h-64 md:h-72 my-10"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.6, ease: "easeOut" }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <Shirt className="h-40 w-40 md:h-48 md:w-48 text-madts-purple/90" strokeWidth={1.5} />
        </div>
        <motion.div 
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          animate={{ 
            scale: [1, 1.05, 1],
            rotate: [0, -2, 2, 0]
          }}
          transition={{ 
            repeat: Infinity, 
            duration: 4, 
            ease: "easeInOut" 
          }}
        >
          <PaintBucket className="h-10 w-10 text-madts-pink" />
        </motion.div>
        <motion.div 
          className="absolute top-[30%] right-[30%]"
          animate={{ 
            y: [0, -5, 0],
            rotate: [-5, 5, -5]
          }}
          transition={{ 
            repeat: Infinity, 
            duration: 3, 
            ease: "easeInOut" 
          }}
        >
          <Palette className="h-8 w-8 text-madts-blue" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default HeroSection;
